import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PageHeader = styled('div', {
  base: {},
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const AmenityList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const AmenityName = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const AmenityDescription = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.5',
    marginTop: '4px',
    whiteSpace: 'pre-wrap',
  },
})

const AmenityMetaRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    marginTop: '12px',
  },
})

const MetaChip = styled('span', {
  base: {
    paddingX: '10px',
    paddingY: '4px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    backgroundColor: '#F1EEFA',
    color: 'quickpass.inkSoft',
  },
})

const DepositTag = styled('span', {
  base: {
    paddingX: '10px',
    paddingY: '4px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
  },
  variants: {
    tone: {
      free: { backgroundColor: '#E7F8EF', color: '#1E7A4D' },
      paid: { backgroundColor: '#FFF4D6', color: '#8A6D1A' },
    },
  },
  defaultVariants: {
    tone: 'free',
  },
})

const ApprovalNote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
    marginTop: '10px',
  },
})

const ComingSoonNote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    marginTop: '12px',
  },
})

const SubHeading = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const BookButton = styled('button', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '14px',
    paddingX: '16px',
    paddingY: '9px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: { opacity: '0.88' },
  },
})

const BookingRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

const BookingInfo = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const BookingName = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const BookingWhen = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const BookingActions = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
})

const StatusTag = styled('span', {
  base: {
    paddingX: '10px',
    paddingY: '3px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    whiteSpace: 'nowrap',
  },
  variants: {
    tone: {
      confirmed: { backgroundColor: '#E7F8EF', color: '#1E7A4D' },
      pending: { backgroundColor: '#FFF4D6', color: '#8A6D1A' },
      ended: { backgroundColor: '#EFEDF5', color: '#5A4F78' },
    },
  },
  defaultVariants: {
    tone: 'pending',
  },
})

const CancelLink = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: '#9B3B3B',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: { opacity: '0.7' },
    _disabled: { opacity: '0.5', cursor: 'default' },
  },
})

const DayHeading = styled('h3', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '700',
    color: 'quickpass.inkSoft',
    marginTop: '16px',
    marginBottom: '8px',
  },
})

const SlotGrid = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
})

const SlotButton = styled('button', {
  base: {
    paddingX: '14px',
    paddingY: '9px',
    borderRadius: 'md',
    border: '1px solid #E4E0EF',
    backgroundColor: '#FFFFFF',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.ink',
    cursor: 'pointer',
    transition: 'all {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      backgroundColor: 'quickpass.primarySoft',
    },
    _disabled: { opacity: '0.5', cursor: 'default' },
  },
})

const BackLink = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    _hover: { opacity: '0.7' },
  },
})

const ErrorBanner = styled('div', {
  base: {
    paddingX: '16px',
    paddingY: '12px',
    borderRadius: 'md',
    backgroundColor: '#FBECEC',
    color: '#9B3B3B',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
  },
})

export {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  QuietText,
  AmenityList,
  AmenityName,
  AmenityDescription,
  AmenityMetaRow,
  MetaChip,
  DepositTag,
  ApprovalNote,
  ComingSoonNote,
  SubHeading,
  BookButton,
  BookingRow,
  BookingInfo,
  BookingName,
  BookingWhen,
  BookingActions,
  StatusTag,
  CancelLink,
  DayHeading,
  SlotGrid,
  SlotButton,
  BackLink,
  ErrorBanner,
}
